<template>
<div :class="classes">
    <div :class="bem('main')">
        <div :class="bem('nick')">
            <span :class="bem('content')">
                <div :class="bem('name')">{{session.user.nick}}</div>
                <div
                    v-if="session.isVIP"
                    :class="bem('side')"
                >
                    <div :class="bem('entry')">
                        <span :class="bem('tip')">会员将于{{dateFormat(new Date(session.user.vip.expiresAt), 'yyyy/MM/dd')}}到期</span>
                        <a
                            target="_black"
                            :class="bem('link')"
                            href="https://www.gaoding.com/vip"
                            @click="handleClick('续费')"
                        >
                            续费
                            <Icon name="chevron-right-outline" />
                        </a>
                    </div>
                </div>
                <div
                    v-else
                    :class="bem('side')"
                >
                    <div :class="bem('entry')">
                        <span :class="bem('tip')">畅享百万可商用素材</span>
                        <a
                            target="_black"
                            :class="bem('link')"
                            href="https://www.gaoding.com/vip"
                            @click="handleClick('升级会员')"
                        >
                            升级会员
                            <Icon name="chevron-right-outline" />
                        </a>
                    </div>
                </div>
            </span>
            <span :class="bem('mark')">{{mark}}</span>
        </div>
        <!-- <div :class="bem('id')">ID: {{session.user.id}}</div> -->
    </div>
</div>

</template>
<script>
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Icon } from '@gaoding/gdui';
import { bemMixin } from '@gaoding/gdui/lib/utils';
import { format as dateFormat } from 'date-fns';
export default {
  name: 'gm-v3-header-user-info',
  components: {
    Icon
  },
  mixins: [bemMixin],
  props: {
    session: {
      type: Object,
      default: function _default() {
        return {};
      },
      require: true
    }
  },
  computed: {
    classes() {
      return this.bem({
        vip: !!this.session.VIP,
        svip: !!this.session.SVIP,
        pvip: !!this.session.PVIP
      });
    },

    mark() {
      if (!this.session.isVIP) {
        return '您还不是会员';
      }

      if (this.session.user.vip.vipId === 1) {
        return '标准版VIP';
      }

      if (this.session.user.vip.vipId === 2) {
        return '尊享版VIP';
      }

      switch (this.session.user.vip.level) {
        case 100:
        case 1:
          return '企业基础版';

        case 200:
        case 2:
          return '企业高级版';

        case 80:
          return '个人专业VIP';

        default:
          return '您还不是会员';
      }
    }

  },
  methods: {
    dateFormat,

    handleClick(type) {
      this.$emit('dropdown-click', type);
    }

  }
};
</script>
<style>
.gm-v3-header-user__menu {
  text-decoration: none;
}
.gm-v3-header-user-info {
  width: 274px;
}
.gm-v3-header-user-info__side {
  color: #444950;
}
.gm-v3-header-user-info__link {
  color: #444950;
}
.gm-v3-header-user-info__main {
  display: flex;
  position: relative;
  height: 120px;
  padding: 0 20px;
  color: #596b96;
  background-repeat: no-repeat;
  background-position: top center;
  background-image: url('./assets/non-vip2x.png');
  background-image: -webkit-image-set(url('./assets/non-vip.png') 1x, url('./assets/non-vip2x.png') 2x);
  background-image: -moz-image-set(url('./assets/non-vip.png') 1x, url('./assets/non-vip2x.png') 2x);
  background-image: -ms-image-set(url('./assets/non-vip.png') 1x, url('./assets/non-vip2x.png') 2x);
  background-image: -o-image-set(url('./assets/non-vip.png') 1x, url('./assets/non-vip2x.png') 2x);
}
.gm-v3-header-user-info__tip {
  font-size: 12px;
  line-height: 18px;
  color: #434951;
  opacity: 0.78;
}
.gm-v3-header-user-info--pvip .gm-v3-header-user-info__main {
  color: #324E90;
  background-image: url('./assets/pvip2x.png');
  background-image: -webkit-image-set(url('./assets/pvip.png') 1x, url('./assets/pvip2x.png') 2x);
  background-image: -moz-image-set(url('./assets/pvip.png') 1x, url('./assets/pvip2x.png') 2x);
  background-image: -ms-image-set(url('./assets/pvip.png') 1x, url('./assets/pvip2x.png') 2x);
  background-image: -o-image-set(url('./assets/pvip.png') 1x, url('./assets/pvip2x.png') 2x);
}
.gm-v3-header-user-info--pvip .gm-v3-header-user-info__mark {
  color: #FDFDFF;
  background: linear-gradient(90deg, #6c8cd5 0%, #5677c5 100%);
}
.gm-v3-header-user-info--pvip .gm-v3-header-user-info__link {
  color: #324E90;
}
.gm-v3-header-user-info--pvip .gm-v3-header-user-info__name {
  color: #324E90;
}
.gm-v3-header-user-info--pvip .gm-v3-header-user-info__tip {
  color: #324E90;
}
.gm-v3-header-user-info--vip .gm-v3-header-user-info__main {
  color: #6F4A12;
  background-image: url('./assets/vip2x.png');
  background-image: -webkit-image-set(url('./assets/vip.png') 1x, url('./assets/vip2x.png') 2x);
  background-image: -moz-image-set(url('./assets/vip.png') 1x, url('./assets/vip2x.png') 2x);
  background-image: -ms-image-set(url('./assets/vip.png') 1x, url('./assets/vip2x.png') 2x);
  background-image: -o-image-set(url('./assets/vip.png') 1x, url('./assets/vip2x.png') 2x);
}
.gm-v3-header-user-info--vip .gm-v3-header-user-info__mark {
  color: #FDFDFF;
  background: linear-gradient(270deg, #a97a42 0%, #c39257 100%);
}
.gm-v3-header-user-info--vip .gm-v3-header-user-info__link {
  color: #6F4A12;
}
.gm-v3-header-user-info--vip .gm-v3-header-user-info__name {
  color: #6F4A12;
}
.gm-v3-header-user-info--vip .gm-v3-header-user-info__tip {
  color: #6F4A12;
}
.gm-v3-header-user-info--svip .gm-v3-header-user-info__main {
  color: #FFD5BC;
  background-image: url('./assets/svip2x.png');
  background-image: -webkit-image-set(url('./assets/svip.png') 1x, url('./assets/svip2x.png') 2x);
  background-image: -moz-image-set(url('./assets/svip.png') 1x, url('./assets/svip2x.png') 2x);
  background-image: -ms-image-set(url('./assets/svip.png') 1x, url('./assets/svip2x.png') 2x);
  background-image: -o-image-set(url('./assets/svip.png') 1x, url('./assets/svip2x.png') 2x);
}
.gm-v3-header-user-info--svip .gm-v3-header-user-info__mark {
  color: #3A3C5F;
  background: linear-gradient(270deg, #f6c2a3 0%, #ffd7bd 100%);
}
.gm-v3-header-user-info--svip .gm-v3-header-user-info__link {
  color: #FFD5BC;
}
.gm-v3-header-user-info--svip .gm-v3-header-user-info__name {
  color: #FFD5BC;
}
.gm-v3-header-user-info--svip .gm-v3-header-user-info__tip {
  color: #FFD5BC;
}
.gm-v3-header-user-info__main .gm-v3-header-user-info__entry {
  margin-top: 10px;
  opacity: 0.7;
}
.gm-v3-header-user-info__nick {
  display: flex;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}
.gm-v3-header-user-info__name {
  max-width: 130px;
  margin-top: 40px;
  font-size: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #434951;
}
.gm-v3-header-user-info__id {
  margin-top: 2px;
  font-size: 12px;
  line-height: 16px;
  opacity: 0.7;
}
.gm-v3-header-user-info__entry {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  line-height: 20px;
}
.gm-v3-header-user-info__link {
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 12px;
}
.gm-v3-header-user-info__link:hover {
  color: #596b96;
}
.gm-v3-header-user-info__link > .g-icon {
  font-size: 20px;
  vertical-align: bottom;
}
.gm-v3-header-user-info__mark {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 8px;
  font-size: 12px;
  line-height: 20px;
  border-radius: 2px;
  font-weight: 400;
  border-radius: 4px 0px 10px 0px;
  color: #FDFDFF;
  background: rgba(0, 0, 0, 0.2);
}

</style>
